import React from 'react';

import { NavContext } from '../contexts/NavContext';
import PageManager from '../routing/PageManager';

import type { FamilyReactProps } from './FamilyReactProps';
import { createForwardRef } from './utils';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface FmlPageProps extends FamilyReactProps {}

interface FmlPageInternalProps extends FmlPageProps {
  forwardedRef?: React.ForwardedRef<HTMLDivElement>;
}

class FmlPageInternal extends React.Component<FmlPageInternalProps> {
  context!: React.ContextType<typeof NavContext>;

  constructor(props: FmlPageInternalProps) {
    super(props);
  }

  render() {
    const { className, children, forwardedRef, ...props } = this.props;

    return this.context.hasFamilyRouter() ? (
      <PageManager
        className={className ? `${className}` : ''}
        routeInfo={this.context.routeInfo}
        forwardedRef={forwardedRef}
        {...props}
      >
        {children}
      </PageManager>
    ) : (
      <div className={className ? `fml-page ${className}` : 'fml-page'} ref={forwardedRef} {...props}>
        {children}
      </div>
    );
  }

  static get displayName() {
    return 'FmlPage';
  }

  static get contextType() {
    return NavContext;
  }
}

export const FmlPage = createForwardRef(FmlPageInternal, 'FmlPage');
